import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'

import { FORGOT_PASSWORD_PROFILE_DISPATCH } from '../../store/reducers/auth/forgotPassword'
import { LOG_IN_URL } from '../../constants/navigation'
import customConfig from 'customConfig'
import CustomForm from '../shared/inputs/CustomForm'
import CustomTextField from '../shared/inputs/CustomTextField'
import SubmitButton from '../shared/button/SubmitButton'
import { FormReturnLink } from '../../auth/components/form-return-link'
import Text from '../text/Text'
import { FormHead } from '../../auth/components/form-head'
import PageTitle from '../shared/pageTitle/PageTitle'

const ForgotPassword = ({
  onFormSubmit,
  dispatchAction,
  forgotPasswordProfile: { error, success, email }
}) => {
  const { t } = useTranslation()
  const pageTitle = t('forgot-password.forgot-password')
  return (
    <>
      <PageTitle title={pageTitle} />
      <FormHead
        title={
          <Stack spacing={1}>
            <Text label={t(customConfig.forgotPasswordLabel)} />
            <Text label={t(customConfig.signWithSocialLabel)} />
          </Stack>
        }
        sx={{ textAlign: { xs: 'center', md: 'left' } }}
      />
      <CustomForm onFormSubmit={onFormSubmit}>
        <Box sx={{ gap: 3, display: 'flex', flexDirection: 'column' }}>
          <CustomTextField
            type='email'
            label={t('common.email-address')}
            error={t(error[FORGOT_PASSWORD_PROFILE_DISPATCH.EMAIL])}
            success={t(success[FORGOT_PASSWORD_PROFILE_DISPATCH.EMAIL])}
            value={email}
            onChange={(value) =>
              dispatchAction(FORGOT_PASSWORD_PROFILE_DISPATCH.EMAIL, value)
            }
          />
          <SubmitButton label={t('forgot-password.send-link')} />
        </Box>
      </CustomForm>
      <FormReturnLink label={t('common.cancel')} to={LOG_IN_URL} />
    </>
  )
}

export default memo(ForgotPassword)
